import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoFixtureIdentity, DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';
import {
  IN_PROGRESS_TAS_FETCH_MATCHERS,
  buildEmployeeTasActivitySearchMatchers,
  buildInProgressTasFetchMatchers,
  buildInProgressTasMatchers,
} from 'tio-employee/demo/products/tas-fixtures';

/**
 * Demo matchers + fixtures for Tuition Assistance: store-routed TAS pages
 * render demo data through their normal store calls. Names derive from the
 * shared fixture identity; application fixtures follow the selected TA
 * payment model.
 *
 * The scenario axis shapes only the employee activity search (home dashboard
 * + benefit-history rows); the walkthrough product-page fixtures are
 * scenario-agnostic and always served.
 */
export function buildTasDemo(
  config: Extract<DemoProductConfig, { kind: 'tas' }>,
  _scenario: DemoScenario,
  identity: DemoFixtureIdentity
): DemoScenarioResolved {
  const activityMatchers = buildEmployeeTasActivitySearchMatchers(
    identity,
    config.scenarioId,
    config.taPaymentModelId,
    config.benefitsMaxedOut
  );
  return {
    matchers: [
      ...activityMatchers,
      ...buildInProgressTasMatchers(identity, config.taPaymentModelId),
    ],
    seed: [],
    fetchMatchers: [
      ...IN_PROGRESS_TAS_FETCH_MATCHERS,
      ...buildInProgressTasFetchMatchers(identity, config.taPaymentModelId),
    ],
  };
}
